import React from 'react';

export type Props = {
  message: string;
  unhandledException?: boolean;
};

const ErrorMessage = (props: Props) => {
  const { message, unhandledException } = props;
  const iconClass = unhandledException
    ? 'fa-light fa-circle-exclamation'
    : 'fa-light fa-face-meh';

  return (
    <div className="error-message">
      <i className={iconClass}></i>
      <h5>{message}</h5>
    </div>
  );
};

export default ErrorMessage;
